// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.misTerminal {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(70, 80, 95, 0.45);
  border-radius: 14px;
  background: #050607;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.025),
    0 22px 70px rgba(0, 0, 0, 0.55);
  overflow: hidden;
}

.misTerminalHeader {
  height: 40px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  border-bottom: 1px solid rgba(70, 80, 95, 0.38);
  background: #030405;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
}

.misTerminalHeader > div {
  display: flex;
  align-items: center;
  gap: 14px;
}

.misTerminalTitle {
  color: #9bdcff;
  font-size: 0.82rem;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.misTerminalDate {
  color: rgba(245, 245, 245, 0.45);
  font-size: 0.78rem;
  font-weight: 800;
}

.misTerminalRight {
  display: flex;
  align-items: center;
  gap: 10px;
}

.misLive {
  color: rgba(245, 245, 245, 0.35);
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.misLive.on {
  color: #21d16b;
}

.misTerminalFeed {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
  scroll-behavior: smooth;
}

.misTerminalFeed::-webkit-scrollbar {
  width: 8px;
}

.misTerminalFeed::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.03);
}

.misTerminalFeed::-webkit-scrollbar-thumb {
  background: rgba(212, 175, 55, 0.35);
  border-radius: 999px;
}

.misPost {
  margin-bottom: 10px;
  border: 1px solid rgba(65, 72, 84, 0.58);
  border-radius: 8px;
  background: #08090b;
  overflow: hidden;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
}

.misPost.open {
  border-color: rgba(80, 95, 115, 0.8);
}

.misPost.critical {
  border-color: rgba(255, 91, 91, 0.75);
}

.misPost.high {
  border-color: rgba(212, 175, 55, 0.62);
}

.misPost.medium {
  border-color: rgba(120, 170, 255, 0.45);
}

.misPost.low {
  border-color: rgba(95, 110, 125, 0.7);
}

.misPostToggle {
  width: 100%;
  display: block;
  border: 0;
  padding: 14px 16px 12px;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.misPostTop {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  margin-bottom: 10px;
}

.misPostIdentity {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.misModuleBadge,
.misStatusBadge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 0.75rem;
  font-weight: 950;
  letter-spacing: 0.08em;
}

.misModuleBadge {
  color: #fff7d6;
  background: linear-gradient(135deg, #c89519, #936b0b);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
}

.misStatusBadge {
  color: #24d06b;
  background: rgba(36, 208, 107, 0.08);
}

.misTime {
  color: rgba(245, 245, 245, 0.42);
  font-size: 0.78rem;
  font-weight: 800;
}

.misChevron {
  color: rgba(245, 245, 245, 0.45);
  font-size: 0.75rem;
}

.misPost h3 {
  margin: 0;
  color: rgba(235, 241, 250, 0.92);
  font-size: 0.92rem;
  line-height: 1.45;
  font-weight: 900;
}

.misQuickBullets {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
}

.misQuickBullets div {
  display: grid;
  grid-template-columns: 14px 1fr;
  gap: 7px;
}

.misQuickBullets span {
  color: rgba(245, 245, 245, 0.45);
}

.misQuickBullets p {
  margin: 0;
  color: rgba(210, 220, 232, 0.76);
  font-size: 0.82rem;
  line-height: 1.45;
}

.misPostBodyWrap {
  padding: 14px 16px 16px;
  border-top: 1px solid rgba(70, 80, 95, 0.38);
}

.misPostBody {
  margin: 0 0 14px;
  color: rgba(220, 230, 240, 0.82);
  font-size: 0.82rem;
  line-height: 1.65;
  white-space: pre-line;
}

.misReadMeta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.misReadMeta div {
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.045);
}

.misReadMeta span,
.misKeyLevels span {
  display: block;
  margin-bottom: 5px;
  color: rgba(245, 245, 245, 0.42);
  font-size: 0.68rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.misReadMeta strong,
.misKeyLevels strong {
  color: rgba(240, 246, 255, 0.9);
  font-size: 0.8rem;
}

.misKeyLevels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 8px 14px;
  margin: 12px 0 14px;
}

.misKeyLevels div {
  display: grid;
  grid-template-columns: minmax(120px, 0.55fr) 1fr;
  gap: 10px;
  align-items: start;
}

.misKeyLevels span {
  margin: 0;
  color: #8edcff;
}

.misCardSections {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.misCardSections section {
  padding: 10px;
  border-radius: 6px;
  border: 1px solid rgba(70, 80, 95, 0.42);
  background: rgba(255, 255, 255, 0.025);
}

.misCardSections h4 {
  margin: 0 0 7px;
  color: #d4af37;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.misCardSections p {
  margin: 0 0 6px;
  color: rgba(220, 230, 240, 0.74);
  font-size: 0.78rem;
  line-height: 1.45;
}

.misTags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 14px;
}

.misTags span {
  padding: 5px 8px;
  border-radius: 999px;
  color: rgba(220, 230, 240, 0.55);
  background: rgba(255, 255, 255, 0.04);
  font-size: 0.68rem;
}

.misPostFooter {
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid rgba(70, 80, 95, 0.32);
  color: rgba(245, 245, 245, 0.36);
  font-size: 0.7rem;
}

.misNoPosts {
  display: grid;
  place-items: center;
  min-height: 360px;
  text-align: center;
  border: 1px dashed rgba(212, 175, 55, 0.25);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.025);
}

.misNoPosts h3 {
  margin: 0 0 8px;
  color: rgba(235, 241, 250, 0.9);
}

.misNoPosts p {
  max-width: 560px;
  margin: 0;
  color: rgba(220, 230, 240, 0.56);
}

@media (max-width: 760px) {
  .misPage {
    padding: 8px;
  }

  .misTerminal {
    height: calc(100vh - 86px);
  }

  .misTerminalHeader {
    height: auto;
    min-height: 44px;
    align-items: flex-start;
    flex-direction: column;
    padding: 10px 12px;
  }

  .misKeyLevels div {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/MarketIntelligenceFeedWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB;;mCAEiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qEAAqE;AACvE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF","sourcesContent":[".misTerminal {\n  height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(70, 80, 95, 0.45);\n  border-radius: 14px;\n  background: #050607;\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.025),\n    0 22px 70px rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n}\n\n.misTerminalHeader {\n  height: 40px;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 14px;\n  border-bottom: 1px solid rgba(70, 80, 95, 0.38);\n  background: #030405;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;\n}\n\n.misTerminalHeader > div {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.misTerminalTitle {\n  color: #9bdcff;\n  font-size: 0.82rem;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n}\n\n.misTerminalDate {\n  color: rgba(245, 245, 245, 0.45);\n  font-size: 0.78rem;\n  font-weight: 800;\n}\n\n.misTerminalRight {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.misLive {\n  color: rgba(245, 245, 245, 0.35);\n  font-size: 0.75rem;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n}\n\n.misLive.on {\n  color: #21d16b;\n}\n\n.misTerminalFeed {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n  scroll-behavior: smooth;\n}\n\n.misTerminalFeed::-webkit-scrollbar {\n  width: 8px;\n}\n\n.misTerminalFeed::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.misTerminalFeed::-webkit-scrollbar-thumb {\n  background: rgba(212, 175, 55, 0.35);\n  border-radius: 999px;\n}\n\n.misPost {\n  margin-bottom: 10px;\n  border: 1px solid rgba(65, 72, 84, 0.58);\n  border-radius: 8px;\n  background: #08090b;\n  overflow: hidden;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;\n}\n\n.misPost.open {\n  border-color: rgba(80, 95, 115, 0.8);\n}\n\n.misPost.critical {\n  border-color: rgba(255, 91, 91, 0.75);\n}\n\n.misPost.high {\n  border-color: rgba(212, 175, 55, 0.62);\n}\n\n.misPost.medium {\n  border-color: rgba(120, 170, 255, 0.45);\n}\n\n.misPost.low {\n  border-color: rgba(95, 110, 125, 0.7);\n}\n\n.misPostToggle {\n  width: 100%;\n  display: block;\n  border: 0;\n  padding: 14px 16px 12px;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.misPostTop {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.misPostIdentity {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.misModuleBadge,\n.misStatusBadge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  border-radius: 4px;\n  padding: 5px 10px;\n  font-size: 0.75rem;\n  font-weight: 950;\n  letter-spacing: 0.08em;\n}\n\n.misModuleBadge {\n  color: #fff7d6;\n  background: linear-gradient(135deg, #c89519, #936b0b);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);\n}\n\n.misStatusBadge {\n  color: #24d06b;\n  background: rgba(36, 208, 107, 0.08);\n}\n\n.misTime {\n  color: rgba(245, 245, 245, 0.42);\n  font-size: 0.78rem;\n  font-weight: 800;\n}\n\n.misChevron {\n  color: rgba(245, 245, 245, 0.45);\n  font-size: 0.75rem;\n}\n\n.misPost h3 {\n  margin: 0;\n  color: rgba(235, 241, 250, 0.92);\n  font-size: 0.92rem;\n  line-height: 1.45;\n  font-weight: 900;\n}\n\n.misQuickBullets {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.misQuickBullets div {\n  display: grid;\n  grid-template-columns: 14px 1fr;\n  gap: 7px;\n}\n\n.misQuickBullets span {\n  color: rgba(245, 245, 245, 0.45);\n}\n\n.misQuickBullets p {\n  margin: 0;\n  color: rgba(210, 220, 232, 0.76);\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n.misPostBodyWrap {\n  padding: 14px 16px 16px;\n  border-top: 1px solid rgba(70, 80, 95, 0.38);\n}\n\n.misPostBody {\n  margin: 0 0 14px;\n  color: rgba(220, 230, 240, 0.82);\n  font-size: 0.82rem;\n  line-height: 1.65;\n  white-space: pre-line;\n}\n\n.misReadMeta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.misReadMeta div {\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.025);\n  border: 1px solid rgba(255, 255, 255, 0.045);\n}\n\n.misReadMeta span,\n.misKeyLevels span {\n  display: block;\n  margin-bottom: 5px;\n  color: rgba(245, 245, 245, 0.42);\n  font-size: 0.68rem;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.misReadMeta strong,\n.misKeyLevels strong {\n  color: rgba(240, 246, 255, 0.9);\n  font-size: 0.8rem;\n}\n\n.misKeyLevels {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 8px 14px;\n  margin: 12px 0 14px;\n}\n\n.misKeyLevels div {\n  display: grid;\n  grid-template-columns: minmax(120px, 0.55fr) 1fr;\n  gap: 10px;\n  align-items: start;\n}\n\n.misKeyLevels span {\n  margin: 0;\n  color: #8edcff;\n}\n\n.misCardSections {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.misCardSections section {\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid rgba(70, 80, 95, 0.42);\n  background: rgba(255, 255, 255, 0.025);\n}\n\n.misCardSections h4 {\n  margin: 0 0 7px;\n  color: #d4af37;\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.misCardSections p {\n  margin: 0 0 6px;\n  color: rgba(220, 230, 240, 0.74);\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n\n.misTags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 14px;\n}\n\n.misTags span {\n  padding: 5px 8px;\n  border-radius: 999px;\n  color: rgba(220, 230, 240, 0.55);\n  background: rgba(255, 255, 255, 0.04);\n  font-size: 0.68rem;\n}\n\n.misPostFooter {\n  margin-top: 14px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(70, 80, 95, 0.32);\n  color: rgba(245, 245, 245, 0.36);\n  font-size: 0.7rem;\n}\n\n.misNoPosts {\n  display: grid;\n  place-items: center;\n  min-height: 360px;\n  text-align: center;\n  border: 1px dashed rgba(212, 175, 55, 0.25);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.025);\n}\n\n.misNoPosts h3 {\n  margin: 0 0 8px;\n  color: rgba(235, 241, 250, 0.9);\n}\n\n.misNoPosts p {\n  max-width: 560px;\n  margin: 0;\n  color: rgba(220, 230, 240, 0.56);\n}\n\n@media (max-width: 760px) {\n  .misPage {\n    padding: 8px;\n  }\n\n  .misTerminal {\n    height: calc(100vh - 86px);\n  }\n\n  .misTerminalHeader {\n    height: auto;\n    min-height: 44px;\n    align-items: flex-start;\n    flex-direction: column;\n    padding: 10px 12px;\n  }\n\n  .misKeyLevels div {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
